<template>
	<div>
		<div v-if="column.type == 'text'">
			<v-text-field hide-details :rounded="column.rounded" dense="column.dense" filled="column.filled" v-if="column.number" v-model="item[column.value]" v-on:blur="$emit('save', item, column.value)" type="number"></v-text-field>
			<v-text-field hide-details :rounded="column.rounded" dense="column.dense" filled="column.filled" v-else v-model="item[column.value]" v-on:blur="$emit('save', item, column.value)"></v-text-field>
		</div>
		<div v-if="column.type == 'textarea'">
			<v-textarea v-model="item[column.value]" dense="column.dense" filled="column.filled"  v-on:blur="$emit('save', item, column.value)"></v-textarea>
		</div>
		<div v-if="column.type == 'select'">
			<v-select
			dense="column.dense" filled="column.filled" 
			v-model="item[column.selected]" 
			:items="column.options"
			:multiple="column.multiple"
			v-bind="column.otherBindingOptions"
			v-on:input="$emit('save', item, column.value)"
			></v-select>
		</div>
		<div v-if="column.type == 'date' || column.type == 'time'">
          <DateTimeField 
            :object="item"
            :type="column.type"
            :objectKey="column.value" 
            :initialValue="item[column.value]" 
            v-bind="column.otherBindingOptions"
            v-on:updated="$emit('save', item, column.value, column.saveDataType )"
          ></DateTimeField>
		</div>
        <div v-if="column.type == 'switch'">
          <v-switch
          v-model="item[column.value]"
          color="green"
          :value="true"
          v-on:change="$emit('save', item, column.value, column.dataType)"
          ></v-switch>
        </div>
	</div>
</template>
<script>
	import DateTimeField from "../../components/tools/DateTimeField.vue";

	export default{
		name: "EditableTableField", 
		props:{
			item: {type: Object}, 
			column: {type: Object }
		},
		components:{
			DateTimeField: DateTimeField
		}
	}
</script>